import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import BootstrapVue3 from 'bootstrap-vue-3';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import Maska from 'maska';

import VueFeather from 'vue-feather';

import '@/assets/scss/config/material/app.scss';
import '@vueform/slider/themes/default.css';
import '@/assets/scss/mermaid.min.css';

// Laravel Echo for real-time WebSocket (Reverb)
import { useEcho } from './composables/useEcho';

import '@/helpers/ag-grid-enterprise';
import '@/helpers/ag-grid-enterprise/styles/ag-grid.css';
import '@/helpers/ag-grid-enterprise/styles/ag-theme-alpine.css';

import { AgGridVue } from 'ag-grid-vue3';

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

// Initialize Echo if Reverb is configured
if (process.env.VUE_APP_REVERB_APP_KEY && process.env.VUE_APP_REVERB_APP_KEY !== 'your-reverb-app-key') {
    const { initEcho } = useEcho();
    initEcho();
}

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

createApp(App)
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVue3)
    .component(VueFeather.type, VueFeather)
    .component('AgGridVue', AgGridVue)
    .component('Vue3EasyDataTable', Vue3EasyDataTable)
    .use(Maska)
    .use(i18n)
    .use(vClickOutside).mount('#app');